import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  get,
} from 'lodash';
import {
  API,
  GlobalActions,
  NavigationHelper,
  TableStations,
  VibeButton,
  viAdd,
  withRouter,
} from 'vibeguide';
import MixSidebar from '../../../../Music/Mixes/Sidebar/MixSidebar';
import './Mixes.scss';

class Mixes extends PureComponent {
  constructor(props) {
    super(props);

    this.sidebarTimeout = null;
  }

  componentDidMount() {
    const qs = NavigationHelper.getParams();
    const isNew = qs.type === 'new';
    const isView = qs.stationId && qs.type !== 'new';

    if (isNew || isView) {
      this.sidebarTimeout = setTimeout(() => {
        this.sidebar(qs.type, qs.stationId);
      }, 1500);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      location: {
        search,
      },
    } = this.props;

    const {
      location: {
        search: prevSearch,
      },
    } = prevProps;

    if (search !== prevSearch) {
      const qs = NavigationHelper.getParams();

      if (qs.stationId || qs.type === 'new') {
        this.sidebar(qs.type, qs.stationId);
      }
    }
  }

  componentWillUnmount() {
    clearTimeout(this.sidebarTimeout);
  }

  /**
   * When the sidebar is closed
   */
  onCloseSidebar = () => {
    const {
      history,
    } = this.props;

    const url = NavigationHelper.updateParams({
      stationId: null,
      type: null,
    }, {
      keepPage: true,
    });

    history(url);
  };

  /**
   * Determine whether or not to show or hide the sidebar
   */
  sidebar = (type, stationId = null) => {
    const {
      setPanel,
    } = this.props;

    setPanel({
      show: true,
      backdrop: type === 'new',
      children: (
        <MixSidebar
          stationId={stationId}
          isNew={type === 'new'}
        />
      ),
      onClose: this.onCloseSidebar,
    });
  };

  render() {
    const {
      user,
      currentLocation,
    } = this.props;

    const locationId = get(currentLocation, '_id', null);

    return (
      <div className="Mixes">
        <TableStations
          columns={[
            '.',
            'Name',
            'Description',
            'Company',
            'Duration',
            'Playlists',
            'Modified',
            'Tags',
            '...',
          ]}
          fetch={API.Location.listMixes}
          fetchProps={{
            filters: {
              _id: locationId,
            },
          }}
          defaultSortBy={{
            label: 'Name',
            attr: 'name',
            direction: 'asc',
          }}
          paginator
          paginatorProps={{
            label: 'Stations',
            urlPaging: true,
            urlFilters: true,
          }}
          toggle
          toggleProps={{
            label: 'Show Archived Stations',
            tooltip: true,
          }}
          bulk
          bulkProps={{
            edit: false,
            add: false,
            block: false,
            remove: false,
            archive: true,
          }}
          rowLink={{
            stationId: '_id',
          }}
          menuItems={[
            { name: 'Archive', userCan: 'mix.delete' },
          ]}
          toolbarProps={{
            customButtons: user.can('mix.create')
              ? [
                (
                  <VibeButton
                    key="button-new-station"
                    text="New Station"
                    color="primary"
                    icon={viAdd}
                    tooltip="New Station"
                    tooltipProps={{
                      placement: 'top',
                    }}
                    link={NavigationHelper.updateParams({
                      type: 'new',
                    })}
                  />
                ),
              ]
              : [],
          }}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.login.user,
    currentLocation: state.locations.currentLocation,
  };
}

const mapDispatchToProps = {
  setPanel: GlobalActions.setPanel,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Mixes));
